module.exports = __webpack_public_path__ + "1a0ba01dd64d905f0011b876711e8bf5.pdf";